import React, { useState } from "react";
import { Navbar, WrapperLayout } from "./styles";
import { Div } from "../../styles/Common";
import logo from "../../assets/images/logo.png";
import logout from "../../assets/icons/logout.svg";
import menu from "../../assets/icons/menu.svg";
import { Link } from "../Link";
import { theme } from "../../styles/theme";
import { deleteLocalUser } from "../../core/services/axiosInstance";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getUserInfo } from "../../utilities/helpers";
import { Dropdown } from "antd";
import { useMediaQuery } from "react-responsive";
import { getUserPermissions, hasPermission } from "../../utilities/permissions";
import { ModalConfirm } from "../../pages/DocumentsDetail/components/modalConfirm";

export const Layout = ({ children }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { id } = useParams();
  const { role } = getUserInfo();
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const isInDocumentsPage = pathname.includes('/documents/') && pathname.includes('/detail/');
  const hasEditDocumentsPermission = id ? hasPermission(id, "Edit Documents") : false;
  const shouldShowModal = isInDocumentsPage && hasEditDocumentsPermission;

  const handleLogout = () => {
    if (shouldShowModal) {
      setPendingNavigation(() => () => {
        deleteLocalUser();
        navigate("/");
      });
      setOpenModalConfirm(true);
    } else {
      deleteLocalUser();
      navigate("/");
    }
  };

  const handleGo = (url) => {
    if (shouldShowModal) {
      setPendingNavigation(() => () => navigate(url));
      setOpenModalConfirm(true);
    } else {
      navigate(url);
    }
  };

  const handleModalClose = () => {
    setOpenModalConfirm(false);
    setPendingNavigation(null);
  };

  const handleModalLeave = () => {
    setOpenModalConfirm(false);
    if (pendingNavigation) {
      pendingNavigation();
    }
    setPendingNavigation(null);
  };

  const menuItems = [
    {
      label: "Home", 
      url: "/projects", 
      permission: true
    },
    {
      label: "Companies", 
      url: "/companies", 
      permission: role === "superAdmin"
    },
    {
      label: "Digitalization templates", 
      url: "/digitalization-documents", 
      permission: role === "superAdmin"
    },
    {
      label: "User Management",
      url: "/user-management",
      permission: role === "superAdmin"
    }
  ];

  const color = (path) => {
    return pathname.includes(path) ? theme.colors.dark : theme.colors.grey1;
  };

  const returnLabel = (label, url) => {
    return (
      <Link color={theme.colors.dark} onClick={() => handleGo(url)}>
        {label}
      </Link>
    );
  };

  const returnLogout = () => {
    return (
      <Div gap="8px">
        <Link onClick={handleLogout}>Logout</Link>
        <Link
          onClick={handleLogout}
          icon={<img alt="logout" src={logout} />}
        />
      </Div>
    );
  };

  const items = [
    {
      key: '1',
      label: pathname.includes("/application") ? returnLabel("Go to Portal", "/projects") : returnLabel("Go to App", "/application"),
    }, 
    {
      key: '2',
      label: returnLogout()
    }
  ];

  const hasWeldingInspector = Object.values(getUserPermissions()).some(role => role.role === "Welding Inspector");

  return (
    <WrapperLayout>
      <ModalConfirm
        openModal={openModalConfirm}
        handleClose={handleModalClose}
        handleLeave={handleModalLeave}
      />
      <Navbar>
        <Div>
          <img alt="logo" src={logo} width={isMobile ? "73px" : "159px"} height={isMobile ? "34px" : "63px"} />
        </Div>
        <Div gap="48px">
          {!isMobile && !pathname.includes("/application") && (
            menuItems.map((ele, indx) => 
              ele.permission && (
                <Link 
                  key={indx}
                  onClick={() => handleGo(ele.url)} 
                  color={color(ele.url)}
                >
                  {ele.label}
                </Link>
              )
            ))
          }
          {(isMobile || !hasWeldingInspector) ? (
            <Div gap="8px">
              <Link onClick={handleLogout}>Logout</Link>
              <Link
                onClick={handleLogout}
                icon={<img alt="logout" src={logout} />}
              />
            </Div>
          ) : (
            <Dropdown menu={{ items }} placement="bottom">
              <img alt="menu" src={menu} width="24px" height="24px" style={{ cursor: "pointer", alignSelf: "center" }} />
            </Dropdown>
          )}
        </Div>
      </Navbar>
      {children}
    </WrapperLayout>
  );
};
